import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'

export const regionsQueryKey = ['profile-photo']

export function useProfilePhoto() {
  async function getProfilePhoto() {
    return await apiClient
      .get(`${SNA_PREFIX}users/me/photo`, {
        responseType: 'blob'
      })
      .then((response) => {
        return response.data
      })
      .then((blob) => {
        return URL.createObjectURL(blob)
      })
  }

  return useQuery({
    queryFn: getProfilePhoto,
    queryKey: regionsQueryKey
  })
}
